export const DISCORD_COMMUNITY_PATH = '/redirect/discord';
export const DISCORD_COMMUNITY_URL = 'https://discord.gg/QZB7pzeMYd';
